import { apiFetch } from './client';

export type CompanyDirectoryEntry = {
    id: number;
    tenantId: number | null;
    companyName: string;
    vatNumber: string;
    fiscalCode: string | null;
    recipientCode: string | null;
    pecEmail: string | null;
    phone: string | null;
    address: Record<string, unknown>;
    notes: string | null;
    currency: string | null;
    active: boolean;
    createdBy: string | null;
    updatedBy: string | null;
    createdAt: string | null;
    updatedAt: string | null;
};

export type CompanyDirectoryPayload = {
    companyName: string;
    vatNumber: string;
    fiscalCode?: string | null;
    recipientCode?: string | null;
    pecEmail?: string | null;
    phone?: string | null;
    address?: Record<string, unknown> | null;
    notes?: string | null;
    currency?: string | null;
    active?: boolean;
};

export async function listCompanyDirectory(query?: string): Promise<CompanyDirectoryEntry[]> {
    const trimmed = query?.trim();
    const searchParam = trimmed ? `?query=${encodeURIComponent(trimmed)}` : '';
    const response = await apiFetch(`/api/tenant/companies${searchParam}`);
    if (!response.ok) {
        const text = await response.text();
        throw new Error(text || 'Impossibile recuperare le anagrafiche aziendali');
    }
    return response.json();
}

export async function createCompanyDirectory(payload: CompanyDirectoryPayload): Promise<CompanyDirectoryEntry> {
    const response = await apiFetch('/api/tenant/companies', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...payload, active: payload.active ?? true }),
    });
    if (!response.ok) {
        const text = await response.text();
        throw new Error(text || 'Impossibile creare la nuova anagrafica aziendale');
    }
    return response.json();
}

export async function updateCompanyDirectory(companyId: number, payload: CompanyDirectoryPayload): Promise<CompanyDirectoryEntry> {
    const response = await apiFetch(`/api/tenant/companies/${companyId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...payload, active: payload.active ?? true }),
    });
    if (!response.ok) {
        const text = await response.text();
        throw new Error(text || 'Impossibile aggiornare l\'anagrafica aziendale');
    }
    return response.json();
}
